import ContactMessage from './ContactMessage';
export default ContactMessage;
